import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { companyDocumentApi } from '../services/api';
import { useAuth } from '../context/AuthContext';
export default function CompanyDocumentReminders() {
  const { user } = useAuth();
  const allowed = user?.role === 'admin' || (user?.role === 'employee' && (!Array.isArray(user.permissions) || user.permissions.includes('documents.view')));
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!allowed) return;
    let active = true;
    companyDocumentApi.reminders().then(r => { if (active) setData(r.data); }).catch(() => {});
    return () => { active = false; };
  }, [allowed]);
  if (!data?.items?.length) return null;
  return <section className="card-swiss p-4 border border-amber-300 bg-amber-50" data-testid="document-reminders"><h2 className="font-semibold">Dokumentfristen · {data.expired} abgelaufen, {data.due} bald fällig</h2><ul className="mt-2 space-y-1 text-sm">{data.items.slice(0, 5).map(item => <li key={item.id}><Link className="underline" to={`/documents?deadline=${item.reminder_status}`}>{item.title}</Link> · {item.days_remaining < 0 ? `seit ${-item.days_remaining} Tagen abgelaufen` : item.days_remaining === 0 ? 'heute fällig' : `in ${item.days_remaining} Tagen fällig`}</li>)}</ul><Link to="/documents?deadline=due" className="underline text-sm inline-block mt-2">Dokumentfristen öffnen</Link></section>;
}
